
/*!

=========================================================
* Vue Argon Dashboard PRO - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from 'vue';
import { brandContext } from './brand/brandContext';
import i18n from './i18n';

import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';
import axios from 'axios'
// router setup
import router from './routes/router';
import LoadScript from 'vue-plugin-load-script';
//walkthrough
import VueIntro from 'vue-introjs';
import 'intro.js/introjs.css';
// /pricing modal infrastructure — load globally so child components in
// src/components/Pricing/ render their .ph-modal-* overlays correctly.
// PricingPage.vue's <style scoped> rules don't cascade into children.
import './assets/scss/_ph-modal.scss';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import CryptoJS from "crypto-js";
// import { VueReCaptcha } from 'vue-recaptcha-v3';

import './assets/css/styles.css';
// Load Project GLAD design tokens at the global (unscoped) level so the
// :root { --glad-* } block actually applies to <html>. Components also
// @import this file inside <style scoped> for SCSS variables ($glad-*),
// but the runtime CSS custom properties only resolve when this file is
// loaded outside of any scoped wrapper.
import './assets/sass/glad-tokens.scss';
// import ElementPlus from 'element-plus'
// import 'element-plus/dist/index.css'

brandContext.boot(); // loads saved branding + sets CSS vars

// Safe Dig Indiana: load blue theme CSS and set brand when company is safedig
const companyFrontend = process.env.VUE_APP_COMPANY_NAME_FRONTEND || '';
if (companyFrontend === 'safedig') {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = '/safedig_custom.css';
  document.head.appendChild(link);
  document.body.classList.add('safedig-theme');
  // Set Safe Dig blue and logo as default brand when no company branding stored
  if (!localStorage.getItem('hot.brandCtx')) {
    brandContext.set({
      primary_color: '#3e7799',
      secondary_color: '#2d5a73',
      slug: 'safedig',
      company_name: 'Safe Dig Indiana',
      logo_url: '/safedig-dashboard-logo.png',
      is_active: true
    });
  }
}

Vue.use(Toast, {
  position: 'top-right',
  timeout: false, // don't auto-close unless you want to
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  // closeButton: true,
  showCloseButtonOnHover: false, // ✅ always visible
  closeButton: "button", // ✅ explicitly use default button
  // showCloseButtonOnHover: true,
});

// Vue.use(VueReCaptcha, {
//   siteKey: '6LdBqGcrAAAAAIhWgNhL5P-KPaB30WyXPtosz8H6', // your site key
//   loaderOptions: {
//     autoHideBadge: true, // hides the bottom-right badge
//   }
// });

Vue.use(LoadScript);
// plugin setup
Vue.use(DashboardPlugin);
// Vue.use(ElementPlus)
// plugin setup
Vue.use(VueIntro);
Vue.prototype.$baseUrl= process.env.VUE_APP_API_URL || 'http://localhost/home-of-training-merged/backend/public/';
Vue.prototype.$downloadUrl= process.env.VUE_APP_DOWNLOAD_URL || 'http://localhost:8000';

const SECRET_KEY = "Train321";
const _setItem = localStorage.setItem;
const _getItem = localStorage.getItem;
// testing
Storage.prototype.setItem = function (key, value) {
  try {
    const rawValue = typeof value === "string" ? value : JSON.stringify(value);
    const encrypted = CryptoJS.AES.encrypt(rawValue, SECRET_KEY).toString();
    return _setItem.call(this, key, encrypted);
  } catch (err) {
    console.warn("Encryption failed, saving as plain:", err);
    return _setItem.call(this, key, value);
  }
};

Storage.prototype.getItem = function (key) {
  const value = _getItem.call(this, key);
  if (!value) return null;

  try {
    const bytes = CryptoJS.AES.decrypt(value, SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);

    if (decrypted) {
      return decrypted;
    }
  } catch {
    return value;
  }

};

Vue.prototype.$http = axios.create({
    baseURL: process.env.VUE_APP_API_URL || 'http://localhost:8000/',
    headers: { 'content-type': 'application/json' },
});

// Attach the Authorization header on EVERY request by reading localStorage
// at request time. This replaces the prior pattern of baking the token into
// axios.create({ headers }) once at app-init — that broke auto-login flows
// like /#/pricing → Start Free Trial → /#/dashboard, where the token didn't
// exist at app-init but DID by the time the dashboard made its first XHR.
Vue.prototype.$http.interceptors.request.use(config => {
  if (typeof NProgress !== 'undefined') NProgress.start();
  const token = localStorage.getItem('hot-token');
  if (token) {
    config.headers = config.headers || {};
    // Set ONLY one case — HTTP headers are case-insensitive but axios
    // stores them as literal keys, so setting both produces a merged
    // `Bearer <t>, Bearer <t>` header that Passport rejects. Laravel is
    // case-insensitive on read so this satisfies legacy callers too.
    delete config.headers.authorization;
    config.headers.Authorization = 'Bearer ' + token;
  }
  return config
}, error => {
  return Promise.reject(error);
});

// before a response is returned stop nprogress
Vue.prototype.$http.interceptors.response.use(response => {
  if (typeof NProgress !== 'undefined') NProgress.done();
  return response
}, error => {
  if (typeof NProgress !== 'undefined') NProgress.done();
  return Promise.reject(error);
});


  // (function(h,o,t,j,a,r){
  //     h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
  //     h._hjSettings={hjid:6380429,hjsv:6};
  //     a=o.getElementsByTagName('head')[0];
  //     r=o.createElement('script');r.async=1;
  //     r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
  //     a.appendChild(r);
  // })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');


/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  render: h => h(App),
  router
});
